import { render, staticRenderFns } from "./similarCars.vue?vue&type=template&id=6da3bc6e&scoped=true&"
import script from "./similarCars.vue?vue&type=script&lang=js&"
export * from "./similarCars.vue?vue&type=script&lang=js&"
import style0 from "./similarCars.vue?vue&type=style&index=0&id=6da3bc6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da3bc6e",
  null
  
)

export default component.exports